import React, { Component } from "react";
import { Mutation } from "react-apollo";
import { connect } from "react-redux";
import { Box } from "reflexbox";
import { toast } from "react-toastify";
import { createCarrier, updateCarrierById } from "../../queries/carriers";
import { deselectCarrier } from "../../actions/select_actions";
import { dismissForm } from "../../actions/ui_actions";

import { Panel, PanelType } from "office-ui-fabric-react/lib/Panel";
import { PrimaryButton } from "office-ui-fabric-react/lib/Button";
import { Formik, Form } from "formik";
import Input from "../../common/Dropdowns/_Input";
import TruckTypeSelect from "../../common/Dropdowns/_TruckTypeSelect";

class CarrierForm extends Component {
  dismissModal = () => {
    this.props.deselectCarrier();
    this.props.dismissForm();
  };

  render() {
    const {
      truck,
      trailer,
      type,
      driver1Tel,
      driver2Tel,
      emptyWeight,
      trolleysSection1,
      trolleysSection2,
      about
    } = this.props.carrier;

    const { addOrEdit } = this.props;

    return (
      <div>
        <Panel
          className="form-panel"
          isBlocking={true}
          isOpen={this.props.visible}
          onDismiss={this.dismissModal}
          isLightDismiss={true}
          type={PanelType.small}
          headerText="Carrier form"
          forceFocusInsideTram={false}
        >
          <Mutation
            mutation={addOrEdit === "edit" ? updateCarrierById : createCarrier}
            refetchQueries={["allCarriers"]}
          >
            {(mutate, { data }) => (
              <Formik
                onSubmit={values => {
                  const id = this.props.carrier.id;
                  const {
                    truck,
                    trailer,
                    type,
                    driver1Tel,
                    driver2Tel,
                    emptyWeight,
                    trolleysSection1,
                    trolleysSection2,
                    about
                  } = values;
                  mutate({
                    variables: {
                      id: id,
                      truck: truck,
                      trailer: trailer,
                      type: type,
                      driver1Tel: driver1Tel,
                      driver2Tel: driver2Tel,
                      emptyWeight: emptyWeight,
                      trolleysSection1: trolleysSection1,
                      trolleysSection2: trolleysSection2,
                      about: about
                    }
                  })
                    .then(response => {
                      this.dismissModal();
                      toast.success(`Success ! ${response}`);
                    })
                    .catch(err => {
                      toast.error(`${err}`);
                    });
                }}
                initialValues={{
                  truck: truck,
                  trailer: trailer,
                  type: type,
                  driver1Tel: driver1Tel,
                  driver2Tel: driver2Tel,
                  emptyWeight: emptyWeight,
                  trolleysSection1: trolleysSection1,
                  trolleysSection2: trolleysSection2,
                  about: about
                }}
                validate={(values, props) => {
                  const errors = {};
                  if (!values.truck) {
                    errors.pickupDate = "Required";
                  }
                  if (!values.trailer) {
                    errors.shipperId = "Required";
                  }
                  return errors;
                }}
                render={props => (
                  <Form>
                    <Box>
                      <Input
                        name="truck"
                        label="Truck"
                        value={props.values.truck}
                        onChange={props.setFieldValue}
                        onBlur={props.setFieldTouched}
                        error={props.errors.truck}
                        touched={props.touched.truck}
                      />
                      <Input
                        name="trailer"
                        label="Trailer"
                        value={props.values.trailer}
                        onChange={props.setFieldValue}
                        onBlur={props.setFieldTouched}
                        error={props.errors.trailer}
                        touched={props.touched.trailer}
                      />
                      <TruckTypeSelect
                        name="type"
                        label="Truck type"
                        value={props.values.type}
                        onChange={props.setFieldValue}
                        onBlur={props.setFieldTouched}
                        error={props.errors.type}
                        touched={props.touched.type}
                      />
                      <Input
                        name="driver1Tel"
                        label="Phone number 1"
                        value={props.values.driver1Tel}
                        onChange={props.setFieldValue}
                        onBlur={props.setFieldTouched}
                        error={props.errors.driver1Tel}
                        touched={props.touched.driver1Tel}
                      />
                      <Input
                        name="driver2Tel"
                        label="Phone number 2"
                        value={props.values.driver2Tel}
                        onChange={props.setFieldValue}
                        onBlur={props.setFieldTouched}
                        error={props.errors.driver2Tel}
                        touched={props.touched.driver2Tel}
                      />
                      <Input
                        name="emptyWeight"
                        label="Empty weight"
                        value={props.values.emptyWeight}
                        onChange={props.setFieldValue}
                        onBlur={props.setFieldTouched}
                        error={props.errors.emptyWeight}
                        touched={props.touched.emptyWeight}
                      />
                      <Input
                        name="trolleysSection1"
                        label="Trolleys section 1"
                        value={props.values.trolleysSection1}
                        onChange={props.setFieldValue}
                        onBlur={props.setFieldTouched}
                        error={props.errors.trolleysSection1}
                        touched={props.touched.trolleysSection1}
                      />
                      <Input
                        name="trolleysSection2"
                        label="Trolleys section 2"
                        value={props.values.trolleysSection2}
                        onChange={props.setFieldValue}
                        onBlur={props.setFieldTouched}
                        error={props.errors.trolleysSection2}
                        touched={props.touched.trolleysSection2}
                      />
                      <Input
                        name="about"
                        label="Additional info"
                        value={props.values.about}
                        onChange={props.setFieldValue}
                        onBlur={props.setFieldTouched}
                        error={props.errors.about}
                        touched={props.touched.about}
                      />
                    </Box>
                    <Box mt={1}>
                      <PrimaryButton
                        type="submit"
                        text="Submit"
                        disable={props.isSubmitting}
                      />
                    </Box>
                  </Form>
                )}
              />
            )}
          </Mutation>
        </Panel>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    carrier: state.selected.carrier
  };
};

export default connect(mapStateToProps, {
  deselectCarrier: deselectCarrier,
  dismissForm: dismissForm
})(CarrierForm);



// WEBPACK FOOTER //
// ./src/common/Forms/_CarrierForm.js